var Curriculog = window.Curriculog || {};

Curriculog.AgendaForm = Backbone.View.extend({
	el: function () {
		return $('#agenda-form');
	},

	events: {
		'blur input[name="agenda-name"]': 'saveName',
		'click .remove-committee': 'removeCommittee',
		'click .add-committee': 'addCommittee',
	},

	initialize: function (options) {
		this.agendaObject = options.agendaObject;
		this.committeeObject = options.committeeObject;
		this.saveCalls = [];

		this.model = {
			id : $('#agenda-form input[name="agenda-id"]').val(),
			name: $('#agenda-form input[name="agenda-name"]').val(),
			calendarID: ($('#agenda-form input[name="agenda-calendarID"]').val() !== '') ?
				$('#agenda-form input[name="agenda-calendarID"]').val() : 0,
			userID: $('#agenda-form input[name="agenda-user"]').val(),
			committees: this.agendaObject.getCommittees(),
			notes: $('#agenda-form textarea[name="agenda-notes"]').val(),
			status: $('#agenda-form input[name="agenda-status"]').val()
		};

		this.listenTo(Backbone, 'AgendaForm:print', this.print)

		this.render();
	},

	render: function () {
		this.setElement($('#agenda-form'));

		// only load ckeditor if we are in edit mode
		if ($('#agenda-notes').length > 0) {
			this.cke = $('#agenda-notes').ckeditorGet();
			this.cke.on('blur', this.saveNotes.bind(this));
		}
	},

	addCommittee: function (event) {
		var t = this;
		var oldCommitteeElements = $('.curriculog-smartfield-dropzone').children();
		event.preventDefault();
		committeesBefore = this.agendaObject.getCommittees();
		this.committeeObject.openCommitteeSelector(function() {
			committeesAfter = t.agendaObject.getCommittees();
			added = t.diff(committeesAfter, committeesBefore);
			deleted = t.diff(committeesBefore, committeesAfter);
			if (added.length > 0 || deleted.length > 0){
				t.saveCommittees(committeesBefore, committeesAfter, oldCommitteeElements);
			}
			t.agendaObject.verticalStretchList();
		});
	},

	removeCommittee: function (event) {
		var t = this;
		var oldCommitteeElements = $('.curriculog-smartfield-dropzone').children();
		event.preventDefault();
		var committeesBefore = this.agendaObject.getCommittees();
		var committeeObj = $(event.currentTarget).closest('.committee-item');

		var errorMsg = 'Are you sure you want to delete '+ $(committeeObj).text() +' from your agenda?';
		new Curriculog.WarningDialog({
			message: errorMsg,
			buttons: {
				'Delete Committee': function() {
					committeeObj.remove();
					committeesAfter = t.agendaObject.getCommittees();
					t.saveCommittees(committeesBefore, committeesAfter, oldCommitteeElements);
					this.close();
				},
				Cancel: function() {
					this.close();
				}
			}
		});
	},

	getProposals: function () {
		var proposals = $('#curriculog-list-column-results-content').children().not('#detail-0');
		var returnVal = [];
		if (proposals.length > 0) {
			$.each(proposals, function (index, value) {
				var proposal = {
					proposal: $(value).attr('id').match(/detail-(\d*)/)[1],
					agenda: $('#agenda-form input[name="agenda-id"]').val(),
					decision: 'none',
					proposalStep: $(value).attr('class').match(/step-(\d*)/)[1],
					user: $('#agenda-form input[name="agenda-user"]').val()
				};
				returnVal.push(proposal);
			});
		}

		return returnVal;
	},

	saveName: function () {
		this.currentField = 'input[name="agenda-name"]';
		var field = this.$(this.currentField);
		var val = field.val().trim();

		if (val !== this.model.name) {
			this.save('name', val, this.model.name);
		}
	},

	saveNotes: function () {
		this.currentField = 'textarea[name="agenda-notes"]';
		var val = this.$(this.currentField).val();
		if (val !== this.model.notes) {
			this.save('notes', val, this.model.notes);
		}
	},

	saveCommittees: function (oldCommittees, newCommittees, oldCommitteeElements) {
		var t = this;
		var deleted = t.diff(oldCommittees, newCommittees);

		if (t.model.status === 'inactive' && deleted.length > 0) {
			// if we are deleting committees then we need to check for
			// ineligible proposals
			this.agendaObject.ineligibleProposals(function() {
				t.save('committees', newCommittees, t.model.committees, oldCommitteeElements);
			}, 'save', oldCommitteeElements);
		} else {
			t.save('committees', newCommittees, t.model.committees, oldCommitteeElements);
		}
	},

	save: function (key, value, oldValue, oldCommitteeElements) {
		var model = this.model;
		var t = this;
		payload = {id: model.id}
		payload[key] = value;
		saveCalls = this.saveCalls;

		saveCalls.push($.ajax({
			type: 'PUT',
			url: '/rpc/agenda/update',
			contentType: 'application/json',
			data: JSON.stringify({'agenda': payload}),
			beforeSend: function () {
				t.addMask();
			},
			complete: function () {
				// re-enable the add/remove proposals button if necessary
				t.resetDisabledClass(model.committees, '#curriculog-proposal-add');
				t.removeMask();
			},
			success: function (response, _, xhr) {
				saveCalls.splice(saveCalls.indexOf(xhr))
				// only update model if save was successful
				model[key] = value;

				if (key === 'name') {
					// Update the title. This is outside the el.
					$('#curriculog-fields-column-agenda-name').text(t.model.name);
				}
				Curriculog.Actions.log('agenda-form-saved');
			},
			error: function () {
				var errorMsg = 'There was an error updating the '+key+' for this agenda.' +
								' Your change was not saved. Please try your change again. ' +
								'<br><br>This problem has been reported.';
				$('#growls').notify('create', 'warning-template', {
					title: 'Warning',
					text: errorMsg
				},{
					expires: false
				});

				// rollback changes if save was not successful
				if (key === 'notes') {
					t.cke.setData(oldValue);
				} else if (key === 'committees') {
					committeesField = $('.curriculog-smartfield-dropzone');
					committeesField.children().remove('.committee-item');
					committeesField.append(oldCommitteeElements);

					// roll back proposals
					t.agendaObject.manageAgendaProposals(t.getProposals());
				} else {
					field = t.$('input[name="agenda-'+key+'"]');
					field.val(oldValue);
				}

				model[key] = oldValue;
			}
		}));
	},

	// useful for finding committees that have been added/removed
	// to find deleted: diff(oldCommittees, newCommittees)
	// to find added: 	diff(newCommittees, oldCommittees)
	diff: function (array1, array2) {
		var diff = [];
		$.each(array1, function (index, value) {
			if ($.inArray(value, array2) < 0) {
				diff.push(value);
			}
		});
		return diff;
	},

	resetDisabledClass: function (value, id) {
		if (value.length > 0) {
			$(id).removeClass('disabled');
		} else {
			$(id).addClass('disabled');
		}
	},

	addMask: function () {
		$(this.currentField).parents('.section-fieldset').mask('Saving...');
	},

	removeMask: function () {
		$(this.currentField).parents('.section-fieldset').unmask();
	}
});
